import { render } from "./DistributorList.vue?vue&type=template&id=5a64c5b6&scoped=true"
import script from "./DistributorList.vue?vue&type=script&lang=js"
export * from "./DistributorList.vue?vue&type=script&lang=js"

import "./DistributorList.vue?vue&type=style&index=0&id=5a64c5b6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5a64c5b6"

export default script